<template>
  <span style="white-space: nowrap;">
    <v-icon style="color:inherit;font-size:120%;margin-left:0.2em;padding-bottom:0.2em;">mdi-sack</v-icon>
    <coins-widget :amount="amount"/> (~ {{this.purchaseValueToString(euroValue)}})
  </span>
</template>

<script>
import purchaseProduct from "@/mixins/purchaseProduct"
import coinMixin from "@/mixins/coinMixin"
import CoinsWidget from "./CoinsWidget.vue"

export default {
  name: "PotWidget",
  mixins: [coinMixin, purchaseProduct],
  components: {
    CoinsWidget,
  },
  props: {
    amount: {
      type: Number,
      required: true
    },
  },
  computed: {
    euroValue: function() {
      if (this.amount <= 0) {
        return 0
      }
      return this.amount * 0.0087
    },
  }
};
</script>